import { render, staticRenderFns } from "./examCopyMarks.html?vue&type=template&id=4e7e3bfd&external"
import script from "./examCopyMarks.vue?vue&type=script&lang=js"
export * from "./examCopyMarks.vue?vue&type=script&lang=js"
import style0 from "./examCopyMarks.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports